import { TFunction } from 'i18next';
import * as Yup from 'yup';

const createFields = (t: TFunction) => [
  {
    name: 'email',
    label: t('forgotPassword.labels.email'),
    defaultValue: '',
    validation: Yup.string()
      .required(t('forgotPassword.email.required', { ns: 'validation' }))
      .email(t('forgotPassword.email.invalid', { ns: 'validation' })),
  },
];

const createDefaultValues = (t: TFunction) => {
  const fields = createFields(t);
  return fields.reduce(
    (acc, item) => {
      return { ...acc, [item.name]: item.defaultValue };
    },
    {} as Record<string, string>
  );
};

const createForgotPasswordSchema = (t: TFunction) => {
  const fields = createFields(t);

  return Yup.object().shape(
    fields.reduce(
      (acc, item) => {
        return {
          ...acc,
          [item.name]: item.validation,
        };
      },
      {} as Record<keyof { email: string }, Yup.Schema<string>>
    )
  );
};

export { createFields, createDefaultValues, createForgotPasswordSchema };
